import React from 'react';
import BarChart from '../../../components/BarChart/BarChart';

const Werknemers = () => {

  const formatValueTooltip = (val) => val + ' duizend werkenden';
  const formatValueY = (val) => val;

  const data = [
    { key: 'Verpleging en verzorging', value:  237 },
    { key: 'Algemene en overige ziekenhuizen', value:  211 },
    { key: 'Gehandicaptenzorg', value: 165 },
    { key: 'Thuiszorg', value: 130 },
    { key: 'Geestelijke gezondheidszorg', value: 84 },
    { key: 'Huisartsenzorg en gezondheidscentra', value: 32 },
    { key: 'Overige zorg', value:  111 },
    { key: 'Universitaire medische centra', value: 70 },
    { key: 'Welzijnszorg', value:  172 },
  ];



  return (

    <div className="vis-werknemers">

      <BarChart
        data={data}
        margin={{ top: 30, right: 0, bottom: 10, left: 300 }}
        barHeight={30}
        domain={[0,237]}
        color={ {fill: '#333', stroke: '#fff'} }
        formatValueTooltip={formatValueTooltip}
        formatValueY={formatValueY}
        padding={0.2}
        ticks={0}
      />

      <div className="vis-total">
        <p>1,2</p>
        <p>miljoen</p>
        <p>werkenden</p>
        <p>in en om de zorg</p>
      </div>

      <div className="vis-credit">
        <p>Aantal werkenden maal duizend per deelsector in de gezondheids- & welzijnszorg in 2016</p>
        <p>Bron: AZWinfo</p>
      </div>

    </div>
  );
}

export default Werknemers;
